import { Injectable, } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import {Observable, tap} from 'rxjs';

import { Deal, DealsService, UserService } from '../core';
import { catchError } from 'rxjs/operators';
import MiscUtil from '../core/utils/misc.util';

@Injectable()
export class DealResolver implements Resolve<Deal> {
    constructor(
        private dealsService: DealsService,
        private router: Router,
        private userService: UserService
    ) {}

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> {
        const linkID = route.params['dealID'].split('-')[0];
        return this.dealsService.get(linkID)
            .pipe(tap( next => {
                    if (route.params['dealID'].includes(MiscUtil.fixedEncodeURIComponent(next.deal.link_title_url))) {
                        return next;
                    } else {
                        this.router.navigateByUrl('/');
                    }
                },
                error => {
                    this.router.navigateByUrl('/');
                }));
    }
}
